// import FormData from 'react-native/Libraries/Network/FormData';
import MyStorage from "../util/storage";
import moment from "moment";

export const googleDownloadLink =
  "https://play.google.com/store/apps/details?id=com.posturecoreandmore";
export const appleDownloadLink = "https://www.apple.com";
export const shareProgramUrl = "https://www.posturecoremore.com"; // for sharing programs
export const baseUrl = "https://posturecoremore.com/api";
// export const baseUrl = "http://localhost:8000/api";
export const mediaUrl = "https://posturecoremore-videos.s3.amazonaws.com/";
const loginAdmin = baseUrl + "/auth/loginAdmin";
const updateAdmin = baseUrl + "/updateAdmin";
// const resetAdminPassword = baseUrl + '/resetAdminPassword';
const filters = baseUrl + "/getFilters"; // merge apis get ages, get goals
const fileUrls = baseUrl + "/getFileUrls";
// const registerUser = baseUrl + '/registerUser';
// const socialLogin = baseUrl + '/auth/socialLogin';
const deleteAccount = baseUrl + "/deleteAccount";
const forgotPassword = baseUrl + "/forgotPassword";
// const updatePushToken = baseUrl + '/updatePushToken';
// const updateSubscribeStatus = baseUrl + '/updateSubscribeStatus';
// const changePassword = baseUrl + '/changePassword';
// const updateProfile = baseUrl + '/updateProfile';
const getSlides = baseUrl + "/getSlides"; // home slider
const getCategories = baseUrl + "/getCategories";
const getCategoriesAdmin = baseUrl + "/getCategoriesAdmin";
const getCategoryVideos = baseUrl + "/getCategoryVideos";
// const searchVideos = baseUrl + '/searchVideos';
// const getSpecialPrograms = baseUrl + '/getSpecialPrograms';
// const getJoinedSpecialPrograms = baseUrl + '/getJoinedSpecialPrograms';
const getSpecialProgramDetails = baseUrl + "/getSpecialProgramDetails";
// const addRemoveFavoriteVideo = baseUrl + '/addRemoveFavoriteVideo';
// const getFavoriteVideos = baseUrl + '/getFavoriteVideos';
// const joinSpecialProgram = baseUrl + '/joinSpecialProgram';
// const addWorkUpTo = baseUrl + '/addWorkUpTo';
// const deleteWorkUpTo = baseUrl + '/deleteWorkUpTo';
// const getWorkUpToList = baseUrl + '/getWorkUpToList';
const getEquipmentNeeds = baseUrl + "/getEquipmentNeeds";
const getChat = baseUrl + "/getChat";
// const getUnreadChatCount = baseUrl + '/getUnreadChatCount';
const sendMessage = baseUrl + "/sendMessage";
// const getNotifications = baseUrl + '/getNotifications';
// const getUnreadNotificationCount = baseUrl + '/getUnreadNotificationCount';
// const clearNotifications = baseUrl + '/clearNotifications';
// const getJoinedPrograms = baseUrl + '/getJoinedPrograms';
// const getProgramExercises = baseUrl + '/getProgramExercises';
// const addProgram = baseUrl + '/addProgram';
// const addWeeklyProgram = baseUrl + '/addWeeklyProgram';
// const updateProgram = baseUrl + '/updateProgram';
// const updateWeeklyProgram = baseUrl + '/updateWeeklyProgram';
// const deleteProgram = baseUrl + '/deleteProgram';
// const joinFriendProgram = baseUrl + '/joinFriendProgram';
// const getProgramDetails = baseUrl + '/getProgramDetails';
// const isAdminOnline = baseUrl + '/isAdminOnline';
const logoutUser = baseUrl + "/logoutUser";
const getDashboardData = baseUrl + "/getDashboardData";
const getUsers = baseUrl + "/getUsers";
const getMyReferrals = baseUrl + "/getMyReferrals";
const enableReferral = baseUrl + "/enableReferral";
const disableReferral = baseUrl + "/disableReferral";
const searchUsers = baseUrl + "/searchUsers";
const updateStatus = baseUrl + "/updateStatus";
const updateFreeStatus = baseUrl + "/updateFreeStatus";
const deleteUser = baseUrl + "/deleteUser";
const addCategory = baseUrl + "/addCategory";
const updateCategory = baseUrl + "/updateCategory";
const deleteCategory = baseUrl + "/deleteCategory";
const addCategoryVideo = baseUrl + "/addCategoryVideo";
const getAllSpecialPrograms = baseUrl + "/getAllSpecialPrograms";
const addSpecialProgram = baseUrl + "/addSpecialProgram";
const deleteSpecialProgram = baseUrl + "/deleteSpecialProgram";
const updateSpecialProgram = baseUrl + "/updateSpecialProgram";
const getSpecialProgramMembers = baseUrl + "/getSpecialProgramMembers";
const getAdminAssignments = baseUrl + "/getAdminAssignments";
const deleteRecommendationRequest = baseUrl + "/deleteRecommendationRequest";
const getRecommendationRequests = baseUrl + "/getRecommendationRequests";
const updateAdminReadRequests = baseUrl + "/updateAdminReadRequests";
const addSlide = baseUrl + "/addSlide";
const addSubscriptionAd = baseUrl + "/addSubscriptionAd";
const getSubscriptionAd = baseUrl + "/getSubscriptionAd";
const deleteSlide = baseUrl + "/deleteSlide";
const addEquipmentNeeds = baseUrl + "/addEquipmentNeeds";
const updateEquipmentNeeds = baseUrl + "/updateEquipmentNeeds";
const deleteEquipmentNeeds = baseUrl + "/deleteEquipmentNeeds";
const getAllChats = baseUrl + "/getAllChats";
const updateChatStatus = baseUrl + "/updateChatStatus";
const sendEmail = baseUrl + "/sendEmail";
const sendNotification = baseUrl + "/sendNotification";
const addMembers = baseUrl + "/addMembers";
const removeMembers = baseUrl + "/removeMembers";
const deleteCategoryVideo = baseUrl + "/deleteCategoryVideo";
const subscriberFreeProgramAccess = baseUrl + "/subscriberFreeProgramAccess";
const getGuides = baseUrl + "/getGuides";
const updateGuides = baseUrl + "/updateGuides";
const addOtherCategoryVideos = baseUrl + "/addOtherCategoryVideos";
const getSettings = baseUrl + "/getSettings";
const saveWelcomeEmail = baseUrl + "/saveWelcomeEmail";
const sortEquipment = baseUrl + "/sortEquipment";
const sortSlides = baseUrl + "/sortSlides";
const addGoal = baseUrl + "/addGoal";
const deleteGoal = baseUrl + "/deleteGoal";
const addStatus = baseUrl + "/addStatus";
const deleteStatus = baseUrl + "/deleteStatus";
const addGuideVideo = baseUrl + "/addGuideVideo";
const updateGuideVideo = baseUrl + "/updateGuideVideo";
const deleteGuideVideo = baseUrl + "/deleteGuideVideo";
const getGuideVideos = baseUrl + "/getGuideVideos";
const getProgramSettings = baseUrl + "/getProgramSettings";
const saveProgramSettings = baseUrl + "/saveProgramSettings";
const updateVideoTitle = baseUrl + "/updateVideoTitle";
const updateGuideVideoTitle = baseUrl + "/updateGuideVideoTitle";
const updateVideoThumb = baseUrl + "/updateVideoThumb";
const mergeCategory = baseUrl + "/mergeCategory";
const getScreenMessages = baseUrl + "/getScreenMessages";
const saveScreenMessages = baseUrl + "/saveScreenMessages";
const saveMainLibraryImage = baseUrl + "/saveMainLibraryImage";
const getMainLibraryImage = baseUrl + "/getMainLibraryImage";
const saveProSettings = baseUrl + "/saveProSettings";
const saveEmailBanner = baseUrl + "/saveEmailBanner";
const setCategoryVisibility = baseUrl + "/setCategoryVisibility";
const updateCategoryOrder = baseUrl + "/updateCategoryOrder";
const updateVideoOrder = baseUrl + "/updateVideoOrder";
const updateGuideVideoOrder = baseUrl + "/updateGuideVideoOrder";

const createMultipartUpload = baseUrl + "/s3/multipart";
// const getUploadedParts = baseUrl + "/s3/multipart/{uploadId}";
const signPartUpload = baseUrl + "/s3/multipart/sign";
const completeMultipartUpload = baseUrl + "/s3/multipart/complete";
// const abortMultipartUpload = baseUrl + "/s3/multipart/{uploadId}";

const addCode = baseUrl + "/addCode";
const getCodes = baseUrl + "/getCodes";
const getCodeUsage = baseUrl + "/getCodeUsage";
const deleteCode = baseUrl + "/deleteCode";
const editCode = baseUrl + "/editCode";
const toggleCodeStatus = baseUrl + "/toggleCodeStatus";

const getShowAtTopLibrary = baseUrl + "/getShowAtTopLibrary";
const setShowAtTopLibrary = baseUrl + "/setShowAtTopLibrary";

const ContentType = "multipart/form-data";
const headers = {
  "Content-Type": ContentType,
};

const axios = require("axios");

const getAccessToken = () => {
  if (MyStorage.isLogin) {
    if (MyStorage.getUser() == null) return "";
    return MyStorage.getUser().access_token;
  }
  return "";
};

const createRequestFunction = ({ url, method = "GET", accessToken = true }) =>
  async function ({ params, onSuccess, onError }) {
    const formData = new FormData();

    if (accessToken) {
      formData.append("access_token", getAccessToken());
    }

    if (params) {
      Object.keys(params).forEach((k) => {
        if (params[k]) {
          formData.append(k, params[k]);
        }
      });
    }

    axios({ method, url, data: formData, headers })
      .then(function (response) {
        onSuccess(response.data);
        if (response.data.msg) {
          if (response.data.msg.includes("Invalid")) {
            alert("Session Expired! Please logout and login again.");
          }
        }
      })
      .catch(function (response) {
        onError && onError(response.message);
      });
  };

const createRequestFunctionNew = ({ url, method = "GET", accessToken = true }) =>
  async function ({ params }) {
    const formData = new FormData();

    if (accessToken) {
      formData.append("access_token", getAccessToken());
    }

    if (params) {
      Object.keys(params).forEach((k) => {
        if (params[k]) {
          formData.append(k, params[k]);
        }
      });
    }

    try {
      const response = await axios({ method, url, data: formData, headers });
      return response.data;
    } catch (err) {
      console.log(err);
    }
  };

const Api = {
  setCategoryVisibility: createRequestFunction({
    url: setCategoryVisibility,
    accessToken: true,
    method: "POST",
  }),

  updateCategoryOrder: createRequestFunction({
    url: updateCategoryOrder,
    accessToken: true,
    method: "POST",
  }),

  updateVideoOrder: createRequestFunction({
    url: updateVideoOrder,
    accessToken: true,
    method: "POST",
  }),

  updateGuideVideoOrder: createRequestFunction({
    url: updateGuideVideoOrder,
    accessToken: true,
    method: "POST",
  }),

  updateGuideVideoTitle: createRequestFunction({
    url: updateGuideVideoTitle,
    accessToken: true,
    method: "POST",
  }),

  saveEmailBanner: async function (image, onSuccess, onError) {
    let params = new FormData();
    params.append("image", image);
    apiCall(saveEmailBanner, params, "POST", headers, onSuccess, onError);
  },

  deleteAccount: createRequestFunction({ url: deleteAccount, method: "POST" }),

  getShowAtTopLibrary: createRequestFunction({ url: getShowAtTopLibrary, method: "GET" }),
  setShowAtTopLibrary: createRequestFunction({ url: setShowAtTopLibrary, method: "POST" }),

  saveProSettings: async function (
    pro_screen_text,
    member_text,
    pro_text,
    client_text,
    member_video,
    pro_video,
    client_video,
    member_video_thumb,
    pro_video_thumb,
    client_video_thumb,
    onSuccess,
    onError
  ) {
    let params = new FormData();
    params.append("pro_screen_text", pro_screen_text);
    params.append("member_text", member_text);
    params.append("pro_text", pro_text);
    params.append("client_text", client_text);
    params.append("member_video", member_video); // fileName
    params.append("pro_video", pro_video); // fileName
    params.append("client_video", client_video); // fileName
    params.append("member_video_thumb", member_video_thumb == null ? "" : member_video_thumb);
    params.append("pro_video_thumb", pro_video_thumb == null ? "" : pro_video_thumb);
    params.append("client_video_thumb", client_video_thumb == null ? "" : client_video_thumb);
    apiCall(saveProSettings, params, "POST", headers, onSuccess, onError);
  },

  saveMainLibraryImage: async function (image, onSuccess, onError) {
    let params = new FormData();
    params.append("image", image);
    apiCall(saveMainLibraryImage, params, "POST", headers, onSuccess, onError);
  },

  getMainLibraryImage: async function (onSuccess, onError) {
    let params = new FormData();
    apiCall(getMainLibraryImage, params, "POST", headers, onSuccess, onError);
  },

  saveScreenMessages: async function (main_library, sp_library, onSuccess, onError) {
    let params = new FormData();
    params.append("main_library", main_library);
    params.append("sp_library", sp_library);
    apiCall(saveScreenMessages, params, "POST", headers, onSuccess, onError);
  },

  getScreenMessages: async function (onSuccess, onError) {
    let params = new FormData();
    apiCall(getScreenMessages, params, "POST", headers, onSuccess, onError);
  },

  mergeCategory: async function (cat_id, parent, onSuccess, onError) {
    let params = new FormData();
    params.append("cat_id", cat_id);
    params.append("parent", parent);
    apiCall(mergeCategory, params, "POST", headers, onSuccess, onError);
  },

  getProgramSettings: async function (onSuccess, onError) {
    let params = new FormData();
    apiCall(getProgramSettings, params, "POST", headers, onSuccess, onError);
  },

  saveProgramSettings: async function (show, onSuccess, onError) {
    let params = new FormData();
    params.append("show", show);
    apiCall(saveProgramSettings, params, "POST", headers, onSuccess, onError);
  },

  getGuideVideos: async function (onSuccess, onError) {
    apiCall(getGuideVideos, null, "GET", headers, onSuccess, onError);
  },

  updateGuideVideo: async function (video_id, title, onSuccess, onError) {
    let params = new FormData();
    params.append("video_id", video_id);
    params.append("title", title);
    apiCall(updateGuideVideo, params, "POST", headers, onSuccess, onError);
  },

  deleteGuideVideo: async function (video_id, onSuccess, onError) {
    let params = new FormData();
    params.append("video_id", video_id);
    apiCall(deleteGuideVideo, params, "POST", headers, onSuccess, onError);
  },

  addGuideVideo: async function (title, thumbnail, file_path, onSuccess, onError) {
    let params = new FormData();
    params.append("title", title);
    let date = new Date();
    params.append("thumbnail", thumbnail, `thumb_${date.getTime()}.jpeg`);
    params.append("file_name", file_path);
    apiCall(addGuideVideo, params, "POST", headers, onSuccess, onError);
  },
  addCategoryVideo: async function (
    type,
    id,
    cat_id,
    title,
    thumbnail,
    file_path,
    onSuccess,
    onError
  ) {
    let params = new FormData();
    params.append("id", id);
    params.append("title", title);
    params.append("cat_id", cat_id);
    params.append("file_name", file_path);
    // let thumbFile = new File([thumbnail], `thumb${new Date()}.jpeg`, {
    //     type: "image/jpeg",
    //     lastModified: new Date()
    // });
    // console.log('thumbFileSize: '+thumbFile.size);
    // console.log('video: ' + video.size);
    params.append("thumbnail", thumbnail, `thumb_${id}.jpeg`);
    // params.append('video', video)
    params.append("type", type);
    console.log("headers", headers);
    apiCall(addCategoryVideo, params, "POST", headers, onSuccess, onError);
  },

  deleteStatus: async function (id, onSuccess, onError) {
    let params = new FormData();
    params.append("id", id);
    apiCall(deleteStatus, params, "POST", headers, onSuccess, onError);
  },

  addStatus: async function (title, onSuccess, onError) {
    let params = new FormData();
    params.append("title", title);
    apiCall(addStatus, params, "POST", headers, onSuccess, onError);
  },

  deleteGoal: async function (id, onSuccess, onError) {
    let params = new FormData();
    params.append("id", id);
    apiCall(deleteGoal, params, "POST", headers, onSuccess, onError);
  },

  addGoal: async function (title, onSuccess, onError) {
    let params = new FormData();
    params.append("title", title);
    apiCall(addGoal, params, "POST", headers, onSuccess, onError);
  },

  sortSlides: async function (models, onSuccess, onError) {
    let params = new FormData();
    params.append("models", models);
    apiCall(sortSlides, params, "POST", headers, onSuccess, onError);
  },

  sortEquipment: async function (models, onSuccess, onError) {
    let params = new FormData();
    params.append("models", models);
    apiCall(sortEquipment, params, "POST", headers, onSuccess, onError);
  },

  saveWelcomeEmail: async function (welcome_email, onSuccess, onError) {
    let params = new FormData();
    params.append("welcome_email", welcome_email);
    apiCall(saveWelcomeEmail, params, "POST", headers, onSuccess, onError);
  },

  getSettings: async function (onSuccess, onError) {
    let params = new FormData();
    apiCall(getSettings, params, "POST", headers, onSuccess, onError);
  },

  addOtherCategoryVideos: async function (type, cat_id, videos, onSuccess, onError) {
    let params = new FormData();
    params.append("cat_id", cat_id);
    params.append("videos", videos);
    params.append("type", type);
    apiCall(addOtherCategoryVideos, params, "POST", headers, onSuccess, onError);
  },

  updateGuides: async function (guides, onSuccess, onError) {
    let params = new FormData();
    params.append("guides", guides);
    apiCall(updateGuides, params, "POST", headers, onSuccess, onError);
  },

  getGuides: async function (onSuccess, onError) {
    let params = new FormData();
    apiCall(getGuides, params, "POST", headers, onSuccess, onError);
  },

  subscriberFreeProgramAccess: async function (access, onSuccess, onError) {
    let params = new FormData();
    if (access != null) params.append("access", access); // 0,1
    else params.append("access", "");
    apiCall(subscriberFreeProgramAccess, params, "POST", headers, onSuccess, onError);
  },

  deleteCategoryVideo: async function (cat_id, video_id, onSuccess, onError) {
    let params = new FormData();
    params.append("cat_id", cat_id);
    params.append("video_id", video_id);
    apiCall(deleteCategoryVideo, params, "POST", headers, onSuccess, onError);
  },

  getCategoryVideos: async function (cat_id, onSuccess, onError) {
    let params = new FormData();
    params.append("cat_id", cat_id);
    apiCall(getCategoryVideos, params, "POST", headers, onSuccess, onError);
  },

  removeMembers: async function (id, onSuccess, onError) {
    let params = new FormData();
    params.append("id", id);
    apiCall(removeMembers, params, "POST", headers, onSuccess, onError);
  },

  addMembers: async function (type, cat_ids, video_ids, user_ids, onSuccess, onError) {
    let params = new FormData();
    params.append("type", type);
    params.append("cat_ids", cat_ids);
    params.append("video_ids", video_ids);
    params.append("user_ids", user_ids);
    apiCall(addMembers, params, "POST", headers, onSuccess, onError);
  },

  sendNotification: async function (recepients, subject, body, onSuccess, onError) {
    let params = new FormData();
    params.append("recepients", recepients);
    params.append("subject", subject);
    params.append("body", body);
    apiCall(sendNotification, params, "POST", headers, onSuccess, onError);
  },

  sendEmail: async function (recepients, subject, body, onSuccess, onError) {
    let params = new FormData();
    params.append("recepients", recepients);
    params.append("subject", subject);
    params.append("body", body);
    apiCall(sendEmail, params, "POST", headers, onSuccess, onError);
  },

  updateChatStatus: async function (chat_status, onSuccess, onError) {
    let params = new FormData();
    params.append("chat_status", chat_status);
    apiCall(updateChatStatus, params, "POST", headers, onSuccess, onError);
  },

  sendMessage: async function (sender, user_id, message, onSuccess, onError) {
    let params = new FormData();
    params.append("sender", sender);
    params.append("user_id", user_id);
    params.append("message", message);
    params.append("user_time", moment().format("YYYY-MM-DD h:mm a"));
    apiCall(sendMessage, params, "POST", headers, onSuccess, onError);
  },

  getChat: async function (user_id, onSuccess, onError) {
    let params = new FormData();
    params.append("user_id", user_id);
    apiCall(getChat, params, "POST", headers, onSuccess, onError);
  },

  getAllChats: async function (onSuccess, onError) {
    let params = new FormData();
    apiCall(getAllChats, params, "POST", headers, onSuccess, onError);
  },

  getEquipmentNeeds: async function (onSuccess, onError) {
    apiCall(getEquipmentNeeds, null, "GET", headers, onSuccess, onError);
  },

  deleteEquipmentNeeds: async function (id, onSuccess, onError) {
    let params = new FormData();
    params.append("id", id);
    apiCall(deleteEquipmentNeeds, params, "POST", headers, onSuccess, onError);
  },

  updateEquipmentNeeds: async function (id, title, detail, image, onSuccess, onError) {
    let params = new FormData();
    params.append("id", id);
    params.append("title", title);
    params.append("detail", detail);
    params.append("image", image);
    apiCall(updateEquipmentNeeds, params, "POST", headers, onSuccess, onError);
  },

  addEquipmentNeeds: async function (title, detail, image, onSuccess, onError) {
    let params = new FormData();
    console.log("token: " + getAccessToken());
    params.append("title", title);
    params.append("detail", detail);
    params.append("image", image);
    apiCall(addEquipmentNeeds, params, "POST", headers, onSuccess, onError);
  },

  getSlides: async function (onSuccess, onError) {
    apiCall(getSlides, null, "GET", headers, onSuccess, onError);
  },

  getSubscriptionAd: async function (onSuccess, onError) {
    apiCall(getSubscriptionAd, null, "GET", headers, onSuccess, onError);
  },

  addSubscriptionAd: async function (image, link, onSuccess, onError) {
    let params = new FormData();
    params.append("link", link);
    params.append("image", image);
    apiCall(addSubscriptionAd, params, "POST", headers, onSuccess, onError);
  },

  addSlide: async function (image, onSuccess, onError) {
    let params = new FormData();
    params.append("link", "https://www.google.com"); // dummy
    params.append("image", image);
    apiCall(addSlide, params, "POST", headers, onSuccess, onError);
  },

  deleteSlide: async function (id, onSuccess, onError) {
    let params = new FormData();
    params.append("id", id);
    apiCall(deleteSlide, params, "POST", headers, onSuccess, onError);
  },

  deleteRecommendationRequest: async function (id, onSuccess, onError) {
    let params = new FormData();
    params.append("id", id);
    apiCall(deleteRecommendationRequest, params, "POST", headers, onSuccess, onError);
  },

  updateAdminReadRequests: async function (onSuccess, onError) {
    let params = new FormData();
    apiCall(updateAdminReadRequests, params, "POST", headers, onSuccess, onError);
  },

  getRecommendationRequests: async function (onSuccess, onError) {
    let params = new FormData();
    apiCall(getRecommendationRequests, params, "POST", headers, onSuccess, onError);
  },

  getSpecialProgramMembers: async function (onSuccess, onError) {
    let params = new FormData();
    apiCall(getSpecialProgramMembers, params, "POST", headers, onSuccess, onError);
  },

  getAdminAssignments: async function (userId, onSuccess, onError) {
    let params = new FormData();
    params.append("user_id", userId);
    apiCall(getAdminAssignments, params, "POST", headers, onSuccess, onError);
  },

  getSpecialProgramDetails: async function (special_pid, onSuccess, onError) {
    let params = new FormData();
    params.append("special_pid", special_pid);
    params.append("user_id", "0"); //
    apiCall(getSpecialProgramDetails, params, "POST", headers, onSuccess, onError);
  },

  getFilters: async function (onSuccess, onError) {
    apiCall(filters, null, "GET", headers, onSuccess, onError);
  },

  deleteSpecialProgram: async function (id, onSuccess, onError) {
    let params = new FormData();
    params.append("id", id);
    apiCall(deleteSpecialProgram, params, "POST", headers, onSuccess, onError);
  },

  updateSpecialProgram: async function (
    image,
    id,
    price,
    age,
    goal,
    title,
    detail,
    inapp_id,
    expiry,
    videos,
    sections,
    programs,
    onSuccess,
    onError
  ) {
    let params = new FormData();
    params.append("id", id);
    params.append("image", image);
    params.append("price", price);
    params.append("age", age);
    params.append("goal", goal);
    params.append("title", title);
    params.append("detail", detail);
    params.append("inapp_id", inapp_id);
    params.append("non_member_expiry", expiry);
    params.append("videos", videos);
    params.append("sections", sections);
    params.append("programs", programs);
    apiCall(updateSpecialProgram, params, "POST", headers, onSuccess, onError);
  },

  addSpecialProgram: async function (
    image,
    price,
    age,
    goal,
    title,
    detail,
    inapp_id,
    expiry,
    videos,
    sections,
    programs,
    onSuccess,
    onError
  ) {
    let params = new FormData();
    params.append("image", image);
    params.append("price", price);
    params.append("age", age);
    params.append("goal", goal);
    params.append("title", title);
    params.append("detail", detail);
    params.append("inapp_id", inapp_id);
    params.append("non_member_expiry", expiry);
    params.append("videos", videos);
    params.append("sections", sections);
    params.append("programs", programs);

    apiCall(addSpecialProgram, params, "POST", headers, onSuccess, onError);
  },

  getAllSpecialPrograms: async function (type, onSuccess, onError) {
    let params = new FormData();
    params.append("type", type);
    apiCall(getAllSpecialPrograms, params, "POST", headers, onSuccess, onError);
  },

  createMultipartUpload: async function (file_name) {
    let params = new FormData();
    params.append("file_name", file_name);
    return axios({
      method: "POST",
      url: createMultipartUpload,
      data: params,
      headers: headers,
    });
  },
  signPartUpload: async function (file_name, uploadId, partNumber) {
    let params = new FormData();
    params.append("file_name", file_name);
    params.append("uploadId", uploadId);
    params.append("partNumber", partNumber);
    return axios({
      method: "POST",
      url: signPartUpload,
      data: params,
      headers: headers,
    });
  },
  completeMultipartUpload: async function (file_name, uploadId, parts, onSuccess, onError) {
    let params = new FormData();
    params.append("file_name", file_name);
    params.append("uploadId", uploadId);
    params.append("parts", JSON.stringify(parts));

    apiCall(completeMultipartUpload, params, "POST", headers, onSuccess, onError);
  },

  addCategoryVideo: async function (
    type,
    id,
    cat_id,
    title,
    thumbnail,
    file_path,
    onSuccess,
    onError
  ) {
    let params = new FormData();
    params.append("id", id);
    params.append("title", title);
    params.append("cat_id", cat_id);
    params.append("file_name", file_path);
    // let thumbFile = new File([thumbnail], `thumb${new Date()}.jpeg`, {
    //     type: "image/jpeg",
    //     lastModified: new Date()
    // });
    // console.log('thumbFileSize: '+thumbFile.size);
    // console.log('video: ' + video.size);
    params.append("thumbnail", thumbnail, `thumb_${id}.jpeg`);
    // params.append('video', video)
    params.append("type", type);
    apiCall(addCategoryVideo, params, "POST", headers, onSuccess, onError);
  },

  updateVideoTitle: async function (video_id, title, onSuccess, onError) {
    let params = new FormData();
    console.log("token: " + getAccessToken());
    console.log("video_id: " + video_id);

    params.append("video_id", video_id);
    params.append("title", title);
    apiCall(updateVideoTitle, params, "POST", headers, onSuccess, onError);
  },

  updateVideoThumb: async function (video_id, thumbnail, onSuccess, onError) {
    let params = new FormData();
    params.append("video_id", video_id);
    params.append("thumbnail", thumbnail, `thumb_${video_id}.jpeg`);
    apiCall(updateVideoThumb, params, "POST", headers, onSuccess, onError);
  },

  deleteCategory: async function (cat_id, onSuccess, onError) {
    let params = new FormData();
    params.append("cat_id", cat_id);
    apiCall(deleteCategory, params, "POST", headers, onSuccess, onError);
  },

  getCategories: async function (type, onSuccess, onError) {
    let params = new FormData();
    // params.append('type', type)
    apiCall(getCategories, params, "POST", headers, onSuccess, onError);
  },

  getCategoriesAdmin: async function (onSuccess, onError) {
    let params = new FormData();

    // params.append('type', type)
    apiCall(getCategoriesAdmin, params, "POST", headers, onSuccess, onError);
  },

  getCategoriesAdminNew: createRequestFunctionNew({
    url: getCategoriesAdmin,
    accessToken: true,
    method: "POST",
  }),

  updateCategory: async function (
    cat_id,
    title,
    detail,
    age,
    goal,
    status,
    image,
    onSuccess,
    onError
  ) {
    let params = new FormData();
    params.append("cat_id", cat_id);
    params.append("title", title);
    params.append("detail", detail);
    params.append("age", age);
    params.append("goal", goal);
    params.append("status", status);
    params.append("has_videos", -1); // delete this field in DB
    if (image != null) params.append("image", image);
    apiCall(updateCategory, params, "POST", headers, onSuccess, onError);
  },

  addCategory: async function (
    type,
    parent_id,
    title,
    detail,
    age,
    goal,
    status,
    image,
    onSuccess,
    onError
  ) {
    let params = new FormData();
    params.append("parent_id", parent_id);
    params.append("title", title);
    params.append("detail", detail);
    params.append("age", age);
    params.append("goal", goal);
    params.append("status", status);
    params.append("image", image);
    params.append("type", type);
    params.append("has_videos", -1); // delete this field in DB
    apiCall(addCategory, params, "POST", headers, onSuccess, onError);
  },

  deleteUser: async function (user_id, onSuccess, onError) {
    let params = new FormData();
    params.append("user_id", user_id);
    apiCall(deleteUser, params, "POST", headers, onSuccess, onError);
  },

  updateFreeStatus: async function (user_id, free_user, onSuccess, onError) {
    let params = new FormData();
    params.append("user_id", user_id);
    params.append("free_user", free_user);
    apiCall(updateFreeStatus, params, "POST", headers, onSuccess, onError);
  },

  updateStatus: async function (user_id, status, onSuccess, onError) {
    let params = new FormData();

    params.append("user_id", user_id);
    params.append("status", status);
    apiCall(updateStatus, params, "POST", headers, onSuccess, onError);
  },

  searchUsers: async function (keyword, onSuccess, onError) {
    let params = new FormData();
    params.append("keyword", keyword);
    apiCall(searchUsers, params, "POST", headers, onSuccess, onError);
  },

  getFileUrls: async function (onSuccess, onError) {
    apiCall(fileUrls, null, "GET", headers, onSuccess, onError);
  },

  getUsers: async function (page_no, onSuccess, onError) {
    let params = new FormData();
    params.append("page_no", page_no);
    apiCall(getUsers, params, "POST", headers, onSuccess, onError);
  },

  getMyReferrals: async function (userId, page_no, onSuccess, onError) {
    let params = new FormData();
    params.append("userId", userId);
    params.append("page_no", page_no);
    apiCall(getMyReferrals, params, "POST", headers, onSuccess, onError);
  },

  enableReferral: async function (proId, userId, onSuccess, onError) {
    let params = new FormData();
    params.append("userId", userId);
    params.append("proId", proId);
    apiCall(enableReferral, params, "POST", headers, onSuccess, onError);
  },

  disableReferral: async function (proId, userId, onSuccess, onError) {
    let params = new FormData();
    params.append("userId", userId);
    params.append("proId", proId);
    apiCall(disableReferral, params, "POST", headers, onSuccess, onError);
  },

  getDashboardData: async function (onSuccess, onError) {
    let params = new FormData();
    apiCall(getDashboardData, params, "POST", headers, onSuccess, onError);
  },

  loginAdmin: async function (email, password, onSuccess, onError) {
    let params = new FormData();
    params.append("email", email);
    params.append("password", password);
    apiCall(loginAdmin, params, "POST", headers, onSuccess, onError, false);
  },

  logoutUser: async function (user_id, onSuccess, onError) {
    let params = new FormData();
    params.append("user_id", user_id);
    apiCall(logoutUser, params, "POST", headers, onSuccess, onError);
  },

  updateAdmin: async function (email, password, onSuccess, onError) {
    let params = new FormData();
    params.append("email", email);
    params.append("password", password);
    apiCall(updateAdmin, params, "POST", headers, onSuccess, onError);
  },

  resetAdminPassword: async function (email, onSuccess, onError) {
    let params = new FormData();
    params.append("type", "admin");
    params.append("email", email);
    apiCall(forgotPassword, params, "POST", headers, onSuccess, onError);
  },

  addCode: createRequestFunction({
    url: addCode,
    method: "POST",
    accessToken: true,
  }),

  getCodes: createRequestFunction({
    url: getCodes,
    method: "POST",
    accessToken: true,
  }),

  getCodeUsage: createRequestFunction({
    url: getCodeUsage,
    method: "POST",
    accessToken: true,
  }),

  deleteCode: createRequestFunction({
    url: deleteCode,
    method: "POST",
    accessToken: true,
  }),

  toggleCodeStatus: createRequestFunction({
    url: toggleCodeStatus,
    method: "POST",
    accessToken: true,
  }),

  editCode: createRequestFunction({
    url: editCode,
    method: "POST",
    accessToken: true,
  }),

  // deleteWorkUpTo: async function (wid, onSuccess, onError) {
  //     let params = new FormData()
  //     params.append('access_token', GLOBAL.accessToken)
  //     params.append('wid', wid)
  //     apiCall(deleteWorkUpTo, params, 'POST', headers, onSuccess, onError)
  // },

  // getWorkUpToList: async function (user_id, onSuccess, onError) {
  //     let params = new FormData()
  //     params.append('access_token', GLOBAL.accessToken)
  //     params.append('user_id', user_id)
  //     apiCall(getWorkUpToList, params, 'POST', headers, onSuccess, onError)
  // },

  // getUnreadChatCount: async function (user_id, onSuccess, onError) {
  //     let params = new FormData()
  //     params.append('access_token', GLOBAL.accessToken)
  //     params.append('user_id', user_id)
  //     apiCall(getUnreadChatCount, params, 'POST', headers, onSuccess, onError)
  // },

  // getNotifications: async function (user_id, onSuccess, onError) {
  //     let params = new FormData()
  //     params.append('access_token', GLOBAL.accessToken)
  //     params.append('user_id', user_id)
  //     apiCall(getNotifications, params, 'POST', headers, onSuccess, onError)
  // },

  // getUnreadNotificationCount: async function (user_id, onSuccess, onError) {
  //     let params = new FormData()
  //     params.append('access_token', GLOBAL.accessToken)
  //     params.append('user_id', user_id)
  //     apiCall(getUnreadNotificationCount, params, 'POST', headers, onSuccess, onError)
  // },

  // clearNotifications: async function (user_id, onSuccess, onError) {
  //     let params = new FormData()
  //     params.append('access_token', GLOBAL.accessToken)
  //     params.append('user_id', user_id)
  //     apiCall(clearNotifications, params, 'POST', headers, onSuccess, onError)
  // },

  // getJoinedPrograms: async function (user_id, onSuccess, onError) {
  //     let params = new FormData()
  //     params.append('access_token', GLOBAL.accessToken)
  //     params.append('user_id', user_id)
  //     apiCall(getJoinedPrograms, params, 'POST', headers, onSuccess, onError)
  // },

  // getProgramExercises: async function (program_id, onSuccess, onError) {
  //     let params = new FormData()
  //     params.append('access_token', GLOBAL.accessToken)
  //     params.append('program_id', program_id)
  //     apiCall(getProgramExercises, params, 'POST', headers, onSuccess, onError)
  // },

  // deleteProgram: async function (master_id, onSuccess, onError) {
  //     let params = new FormData()
  //     params.append('access_token', GLOBAL.accessToken)
  //     params.append('master_id', master_id)
  //     apiCall(deleteProgram, params, 'POST', headers, onSuccess, onError)
  // },

  // getProgramDetails: async function (user_id, master_id, onSuccess, onError) {
  //     let params = new FormData()
  //     params.append('access_token', GLOBAL.accessToken)
  //     params.append('user_id', user_id)
  //     params.append('master_id', master_id)
  //     apiCall(getProgramDetails, params, 'POST', headers, onSuccess, onError)
  // },

  // getJoinedSpecialPrograms: async function (user_id, onSuccess, onError) {
  //     let params = new FormData()
  //     params.append('access_token', GLOBAL.accessToken)
  //     params.append('user_id', user_id)
  //     apiCall(getJoinedSpecialPrograms, params, 'POST', headers, onSuccess, onError)
  // },

  // joinSpecialProgram: async function (special_pid, user_id, join, onSuccess, onError) {
  //     let params = new FormData()
  //     params.append('access_token', GLOBAL.accessToken)
  //     params.append('special_pid', special_pid)
  //     params.append('user_id', user_id)
  //     params.append('join', join)
  //     apiCall(joinSpecialProgram, params, 'POST', headers, onSuccess, onError)
  // },

  // getFavoriteVideos: async function (user_id, onSuccess, onError) {
  //     let params = new FormData()
  //     params.append('access_token', GLOBAL.accessToken)
  //     params.append('user_id', user_id)
  //     apiCall(getFavoriteVideos, params, 'POST', headers, onSuccess, onError)
  // },

  // addRemoveFavoriteVideo: async function (user_id, video_id, onSuccess, onError) {
  //     let params = new FormData()
  //     params.append('access_token', GLOBAL.accessToken)
  //     params.append('user_id', user_id)
  //     params.append('video_id', video_id)
  //     apiCall(addRemoveFavoriteVideo, params, 'POST', headers, onSuccess, onError)
  // },

  // addWorkUpTo: async function (user_id, video_id, title, onSuccess, onError) {
  //     let params = new FormData()
  //     params.append('access_token', GLOBAL.accessToken)
  //     params.append('user_id', user_id)
  //     params.append('video_id', video_id)
  //     params.append('title', title)
  //     apiCall(addWorkUpTo, params, 'POST', headers, onSuccess, onError)
  // },

  // registerUser: async function (email, fname, lname, password, onSuccess, onError) {
  //     let params = new FormData()
  //     params.append('email', email)
  //     params.append('fname', fname)
  //     params.append('lname', lname)
  //     params.append('password', password)
  //     apiCall(registerUser, params, 'POST', headers, onSuccess, onError)
  // },

  // sendEmail: async function (email, subject, body, onSuccess, onError) {
  //     let params = new FormData()
  //     params.append('email', email)
  //     params.append('subject', subject)
  //     params.append('body', body)
  //     apiCall(sendEmail, params, 'POST', headers, onSuccess, onError)
  // },

  forgotPassword: async function (email, onSuccess, onError) {
    let params = new FormData();
    params.append("email", email);
    apiCall(forgotPassword, params, "POST", headers, onSuccess, onError);
  },

  // updateSubscribeStatus: async function (subscriber, onSuccess, onError) {
  //     let params = new FormData()
  //     params.append('access_token', GLOBAL.accessToken)
  //     params.append('subscriber', subscriber)
  //     apiCall(updateSubscribeStatus, params, 'POST', headers, onSuccess, onError)
  // },

  // changePassword: async function (old_password, password, onSuccess, onError) {
  //     let params = new FormData()
  //     params.append('access_token', GLOBAL.accessToken)
  //     params.append('old_password', old_password)
  //     params.append('password', password)
  //     apiCall(changePassword, params, 'POST', headers, onSuccess, onError)
  // },

  // searchVideos: async function (keyword, onSuccess, onError) {
  //     let params = new FormData()
  //     params.append('access_token', GLOBAL.accessToken)
  //     params.append('keyword', keyword)
  //     apiCall(searchVideos, params, 'POST', headers, onSuccess, onError)
  // },
};

const apiCall = (url, params, method, headers, onSuccess, onError, accessToken = true) => {
  if (accessToken && params) {
    params.append("access_token", getAccessToken());
  }

  axios({
    method: method,
    url: url,
    data: params,
    headers: headers,
  })
    .then(function (response) {
      //handle success
      // console.log(JSON.stringify(response.data));
      onSuccess && onSuccess(response.data);
      if (response.data.msg) {
        if (response.data.msg.includes("Invalid")) {
          alert("Session Expired! Please logout and login again.");
        }
      }
    })
    .catch(function (response) {
      //handle error

      onError && onError(response.message);
    });
};

// const apiCallFile = (url, params, method, headers, onSuccess, onError) => {
//     console.log('url: ' + url);
//     fetch(url, {
//         method: method,
//         headers: headers,
//         body: params
//     })
//         .then(response => response.json())
//         .then(result => {
//             console.log(JSON.stringify(result));
//             onSuccess(result);
//         })
//         .catch(err => {
//             console.log(err)
//             onError(err);
//         });
// };

export default Api;
